import classnames from 'classnames';
import React from 'react';

import { Tag } from '@flixbus/honeycomb-react';

import { crewDataNA } from 'constants/crewDetails';

import styles from './styles.module.css';

const JobList = ({
	jobs = [],
	jobLabel = 'Job(s)',
	extraJobLabelClasses = '',
	extraClasses = '',
	isTag = false,
	isBadge = false,
}) => {
	return (
		<div className={styles.jobList}>
			<span className={classnames(extraClasses)}>{`${jobLabel}: `}</span>
			{jobs && jobs.length > 0 ? (
				jobs.map(({ id, code }) =>
					isTag ? (
						<Tag key={id} display="outlined" extraClasses={styles.jobTag}>
							<span className={classnames(extraJobLabelClasses)}>{code}</span>
						</Tag>
					) : isBadge ? (
						<span key={id} className={classnames(styles.job, extraJobLabelClasses)}>
							{code}
						</span>
					) : (
						<span key={id} className={classnames(extraJobLabelClasses)}>
							{code}
						</span>
					)
				)
			) : (
				<span className={styles.noData}>{crewDataNA}</span>
			)}
		</div>
	);
};

export default JobList;
